
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import Flex from 'shared/library/atoms/Flex';
import { AnimatedIcon } from 'shared/library/atoms/Icon';
const StyleGuideLoading = () => (<Flex width={1} alignItems="center" justifyContent="center" flex="1 0 0">
    <AnimatedIcon name="loader" autoplay loop/>
  </Flex>);
export default StyleGuideLoading;

    async function __Next_Translate__getStaticProps__197303e50c7__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'shared/library//StyleGuide/StyleGuideLoading',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__197303e50c7__ as getStaticProps }
  